<p-menubar [model]="items" styleClass="bg-white">
  <ng-template pTemplate="start">
    <ng-container *ngTemplateOutlet="startTemplate"></ng-container>
  </ng-template>

  <ng-template pTemplate="end">
    <ng-container *ngTemplateOutlet="endTemplate"></ng-container>
  </ng-template>
</p-menubar>
